"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var registerSource_1 = require("../../registerSource");

var DragSourceMonitorImpl_1 = require("../../DragSourceMonitorImpl");

function useDragSourceMonitor(type, source, manager) {
  var monitor = react_1.useMemo(function () {
    return new DragSourceMonitorImpl_1.default(manager);
  }, [manager]);
  react_1.useEffect(function registerSourceWithMonitor() {
    var _a = registerSource_1.default(type, source, manager),
        handlerId = _a.handlerId,
        unregister = _a.unregister;

    monitor.receiveHandlerId(handlerId);
    return unregister;
  }, [monitor]);
  return monitor;
}

exports.useDragSourceMonitor = useDragSourceMonitor;